import React from "react";
import { Button, Box, Typography, Grid, Paper } from "@mui/material";

const TutorialPage = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={4}>
      <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
        Tutorial
      </Typography>
      
      {/* Navigation Buttons */}
      <Box display="flex" justifyContent="center" gap={2} mb={4}>
        <Button variant="contained" color="primary">Register</Button>
        <Button variant="contained" color="primary">Editing</Button>
        <Button variant="contained" color="primary">RSVP</Button>
        <Button variant="contained" color="secondary">FAQ</Button>
      </Box>
      
      {/* Video Section */}
      <Box display="flex" justifyContent="center" alignItems="center" mb={4}>
        <iframe 
          width="560" 
          height="315" 
          src="https://www.youtube.com/embed/WUPRFyeUwCU?si=1cB5PZU2DTM4Jue8" 
          title="YouTube video player" 
          frameBorder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowFullScreen>
        </iframe>
      </Box>
    </Box>
  );
};

export default TutorialPage;